import { useSelector } from 'react-redux';

import { selectors } from '../store/dux/permissions-dux';

export function usePermission(name) {
  const permissions = useSelector(selectors.all);
  return permissions.includes(name);
}
